import React, { useState } from 'react';
import {Menu} from 'antd';
import {Link} from 'react-router-dom';
const renderMenuItem = (item) => {
    return (
        <Menu.Item key={item.key} style={{fontSize:'12px'}}>
            <Link to={item.key+ (item.query || '')} replace>
                <span className="nav-text">{item.title}</span>
            </Link>
        </Menu.Item>
    )   

}

const renderSubMenuItem = (item) => {
    return (
        <Menu.SubMenu key = {item.key} 
            title = {
                <span>
                    {item.icon}
                    <span className="nav-text">{item.title}</span>
                </span>
            } 
        >
            {item.subs.map(item=>item.render ? renderMenuItem(item) : "")};
        </Menu.SubMenu>
)};

export  default ({menus,...props}) => {
    const [dragItems] = useState(menus);
  //  console.log(props)
    return (
        <Menu {...props} theme={'light'} >
        {dragItems.map((item)=>{
        if(item.render){
            if(item.access){
                // 当前角色在菜单中
                if(item.roles.indexOf(props.roles) !== -1 || item.roles.indexOf("*") !== -1){
                // 是否存在子菜单
                    if(item.subs){
                        return  (
                            <Menu.SubMenu key={item.key} title = {
                                <span>
                                    {item.icon}
                                    <span className="nav-text">{item.title}</span>
                                </span>
                            }>
                                            
                            {item.subs.map(child => {
                                if(child.render){
                                    if(child.roles && (child.roles.indexOf(props.roles) !== -1 || 
                                        child.roles.indexOf("*") !== -1 )){
                                            return   (
                                                <Menu.Item
                                                    key={child.key} style={{fontSize:'12px'}} roles={props.roles}
                                                >
                                                    <Link to={child.key+ (child.query || '')} replace>
                                                        <span className="nav-text">{child.title}</span>
                                                    </Link>
                                                    </Menu.Item>
                                            ) 
                                        }}
                            })}
                            </Menu.SubMenu>
                        )
                    }else{
                        return   (  
                               
                            <Menu.Item key={item.key} style={{fontSize:'12px'}}>
                                <Link to={item.key+ (item.query || '')} replace>
                                        <span className="nav-text">{item.title}</span>
                                </Link>
                             </Menu.Item>
                             
                        )
                    }
                }
            }
        }
    
    })}
    </Menu>
    )

}


// export  default ({menus,...props}) => {
//     const [dragItems] = useState(menus);
//         // return (
//     //     <Menu {...props} theme={'light'} >
//     //         {dragItems.map((item,index)=>(
//     //           // item.subs ? renderSubMenuItem(item) : renderMenuItem(item)
//     //             item.render ? ( item.subs ? renderSubMenuItem(item) : renderMenuItem(item) ) : ""
//     //         ))}
//     //     </Menu>
//     // );
// }